import React, { useEffect, memo } from 'react';
import TranslationsScope from '@client/components/shared/translation/TranslationsScope';
import { track } from '@client/helpers';
import DoiSuccessContent from './DoiSuccessContent';

const DoiSuccess = memo(() => {
    useEffect(() => {
        track('onboarding.success_action', {
            success_description: 'sendDoiSuccess',
        });
    }, []);

    return (
        <TranslationsScope path="doiSuccessOverlay">
            <DoiSuccessContent />
        </TranslationsScope>
    );
});

export default DoiSuccess;
